export default __webpack_public_path__ + "static/doubled-532ff247766d4fc5a65a474755ca2b71.png";